import { useEffect, useState } from 'react';
import { getSiteInfo } from '../utils';

export type EditorType = 'santa_editor' | 'editor_x';

const EDITORX_MANAGE_DOMAIN = 'https://manage.editorx.com';
const EDITORX_CREATE_DOMAIN = 'https://create.editorx.com';

const useEditorType = () => {
  const [editorType, setEditorType] = useState<EditorType | null>(null);

  useEffect(() => {
    const fetchEditorType = async () => {
      while (editorType === null) {
        getSiteInfo((data) => {
          const isEditorX =
            data.baseUrl.startsWith(EDITORX_MANAGE_DOMAIN) ||
            data.baseUrl.startsWith(EDITORX_CREATE_DOMAIN);
          setEditorType(isEditorX ? 'editor_x' : 'santa_editor');
        });

        await new Promise((resolve) => setTimeout(resolve, 1000)).catch((error) =>
          console.error('Error occurred while executing effects:', error),
        )

      }
    };

    fetchEditorType().catch((error) =>
      console.error('Error occurred while executing effects:', error),
    );
  }, [editorType]);

  return { editorType, isEditorX: editorType === 'editor_x' };
};

export default useEditorType;
